// Polis › Suivis (15 octobre 2026) : le tableau de bord des personnalités que l’organisation suit.
// Jamais de genre deviné ; jamais un nombre de mentions : le volume se dit rapporté à l’habitude.
export default {
  titre: 'Suivis',
  sousTitre: 'Aucune personnalité suivie · {max} suivis possibles | {n} personnalité suivie sur {max} · écoutée chaque jour | {n} personnalités suivies sur {max} · écoutées chaque jour',
  chargement: 'Chargement des suivis…',
  periode: { aria: 'Période', jours7: '7 jours', jours30: '30 jours' },
  suivre: 'Suivre une personnalité',
  quand: { aujourdhui: 'aujourd’hui', hier: 'hier' },
  alertes: {
    titre: 'Ce qui a bougé depuis hier',
    toutLu: 'Tout marquer comme lu',
    nouvelle: 'Nouvelle',
    // Le compte en tête de la carte d'une personnalité (16 octobre 2026).
    nouvelles: '{n} nouvelles | {n} nouvelle | {n} nouvelles',
    voirFiche: 'Voir la fiche',
    autres: 'Voir l’autre changement | Voir l’autre changement | Voir les {n} autres changements',
    reduire: 'Réduire',
    calme: 'Rien n’a bougé depuis hier : aucune alerte sur vos suivis.',
  },
  tableau: {
    titre: 'Les personnalités suivies',
    aide: 'note de 0 à 100 selon ce qui se dit, 50 étant neutre · part de voix parmi vos personnalités suivies',
    personnalite: 'Personnalité',
    note: 'Note',
    courbe: '{n} jours',
    volume: 'Volume',
    part: 'Part de voix',
    theme: 'De quoi on parle',
    alertes: 'Alertes',
    ecart: '{n} sur 7 jours',
    fois: '×{v}',
    pct: '{n} %',
    inconnu: '·',
    nouvelles: 'nouvelle alerte | nouvelle alerte | nouvelles alertes',
    premiere: 'Première écoute en cours',
    courbeAria: 'La note de {nom} sur la période : {note} au dernier jour',
  },
  courbes: {
    titre: 'Leurs notes, jour par jour',
    aide: 'choisir un nom pour le mettre en avant',
    legende: 'Mettre une personnalité en avant',
    aria: 'Les notes des personnalités suivies, jour par jour, sur la période',
    aujourdhui: 'aujourd’hui',
  },
  vide: {
    titre: 'Aucune personnalité suivie',
    texte: 'Suivre une personnalité déclenche une écoute quotidienne : ce qu’on en dit, ses propres mots, chaque citation avec sa source, ceux qui en parlent, ses positions sujet par sujet, et une alerte quand quelque chose bouge. Votre organisation peut en suivre {max}.',
    annuaire: 'Ouvrir l’annuaire',
  },
}
